var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmap2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1620,
    height: 2390,
    viewBox: "0 0 1620 2390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "INFOS_FRAME",
    x: 358,
    y: 110,
    width: 655,
    height: 177,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594",
    x: 507,
    y: 385,
    width: 655,
    height: 177,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-2",
    x: 167,
    y: 513,
    width: 655,
    height: 177,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-3",
    x: 862,
    y: 446,
    width: 655,
    height: 207,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-4",
    x: 314,
    y: 779,
    width: 655,
    height: 153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-5",
    x: 301,
    y: 1021,
    width: 655,
    height: 152,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-6",
    x: 11,
    y: 1159,
    width: 655,
    height: 143,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "infos_rect",
    x: 900,
    y: 1049,
    width: 655,
    height: 140,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "info_eco",
    x: 782,
    y: 1168,
    width: 655,
    height: 183,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-7",
    x: 965,
    y: 1348,
    width: 655,
    height: 127,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-8",
    x: 470,
    y: 1331,
    width: 655,
    height: 149,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-9",
    x: 129,
    y: 1440,
    width: 655,
    height: 166,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-10",
    x: 0,
    y: 1836,
    width: 655,
    height: 122,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "infos_rect-2",
    x: 604,
    y: 1877,
    width: 655,
    height: 143,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1594-11",
    x: 829,
    y: 1990,
    width: 655,
    height: 127,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7008",
    "data-name": "Group 7008",
    transform: "translate(-247 -2046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6964",
    "data-name": "Group 6964",
    transform: "translate(1244.172 1514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    transform: "translate(140.828 532)",
    fill: "#7d47a0",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 131,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2022",
    "data-name": 2022,
    transform: "translate(167.028 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2022"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980",
    transform: "translate(875.172 3255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-2",
    "data-name": "Rectangle 1416",
    transform: "translate(140.828 532)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 131,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2022-2",
    "data-name": 2022,
    transform: "translate(167.028 574)",
    fill: "#7d47a0",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2023"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6991",
    "data-name": "Group 6991",
    transform: "translate(0 -933)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "ROADMAP",
    transform: "matrix(0.588, -0.809, 0.809, 0.588, 1297.287, 3265.785)",
    fill: "#a079b9",
    fontSize: 39,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ROADMAP")), /*#__PURE__*/React.createElement("text", {
    id: "TEAM",
    transform: "matrix(0.829, -0.559, 0.559, 0.829, 1188.18, 3451.521)",
    fill: "#a079b9",
    fontSize: 30,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TEAM")), /*#__PURE__*/React.createElement("text", {
    id: "BLOCKCHAIN",
    transform: "translate(796.474 3657.798) rotate(-42)",
    fill: "#a079b9",
    fontSize: 23,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BLOCKCHAIN")), /*#__PURE__*/React.createElement("text", {
    id: "TEMPLATES",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 1311.259, 3766.293)",
    fill: "#a079b9",
    fontSize: 28,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TEMPLATES")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS",
    transform: "translate(923.365 4145.609) rotate(-36)",
    fill: "#a079b9",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS-2",
    "data-name": "IT\\xC9RATIONS",
    transform: "translate(770.09 4321.203) rotate(-52)",
    fill: "#a079b9",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS-3",
    "data-name": "IT\\xC9RATIONS",
    transform: "translate(469.787 4697.607) rotate(26)",
    fill: "#a079b9",
    fontSize: 22,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS-4",
    "data-name": "IT\\xC9RATIONS",
    transform: "translate(1052.925 4587.625) rotate(-3)",
    fill: "#a079b9",
    fontSize: 17,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS-5",
    "data-name": "IT\\xC9RATIONS",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 1466.73, 4583.045)",
    fill: "#de8579",
    fontSize: 25,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "IT\\xC9RATIONS-6",
    "data-name": "IT\\xC9RATIONS",
    transform: "translate(1545.604 4898.583) rotate(48)",
    fill: "#de8579",
    fontSize: 23,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ITERATIONS")), /*#__PURE__*/React.createElement("text", {
    id: "FANS",
    transform: "translate(1320.818 4997.129) rotate(-13)",
    fill: "#de8579",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FANS")), /*#__PURE__*/React.createElement("text", {
    id: "NEW_FEATURES",
    "data-name": "NEW FEATURES",
    transform: "translate(811.201 4356.212) rotate(26)",
    fill: "#a079b9",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW FEATURES")), /*#__PURE__*/React.createElement("text", {
    id: "NEW_FEATURES-2",
    "data-name": "NEW FEATURES",
    transform: "translate(719.946 5089.426) rotate(28.999)",
    fill: "#a079b9",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW FEATURES")), /*#__PURE__*/React.createElement("text", {
    id: "PRO_CREATORS",
    "data-name": "PRO CREATORS",
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1116.267, 3968.773)",
    fill: "#a079b9",
    fontSize: 28,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRO CREATORS")), /*#__PURE__*/React.createElement("text", {
    id: "USERS_CREATORS",
    "data-name": "USERS CREATORS",
    transform: "matrix(0.469, 0.883, -0.883, 0.469, 920.473, 4229.277)",
    fill: "#a079b9",
    fontSize: 28,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USERS CREATORS")), /*#__PURE__*/React.createElement("text", {
    id: "SVG",
    transform: "translate(1254.527 3592.496) rotate(18)",
    fill: "#a079b9",
    fontSize: 28,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SVG")), /*#__PURE__*/React.createElement("text", {
    id: "fundraising",
    transform: "matrix(0.755, 0.656, -0.656, 0.755, 1314.846, 3402.708)",
    fill: "#a079b9",
    fontSize: 20,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FUNDRAISING"))), /*#__PURE__*/React.createElement("g", {
    id: "Q",
    transform: "translate(0 -647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q1",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q1"))), /*#__PURE__*/React.createElement("g", {
    id: "Component_196_2",
    "data-name": "Component 196 \\u2013 2",
    transform: "translate(614 2162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_1",
    transform: "translate(-114.262 -358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6969",
    "data-name": "Group 6969",
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-3",
    "data-name": "Rectangle 1416",
    transform: "translate(143.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 579,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 577,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NFT_MAKER_VISION-whitebook",
    "data-name": "NFT MAKER VISION-whitebook",
    transform: "translate(171.272 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Whitepaper v0.1-NFT Maker")))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_1_INFOS"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -367, -116)",
    filter: "url(#INFOS_FRAME)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "INFOS_FRAME-2",
    "data-name": "INFOS_FRAME",
    width: 637,
    height: 159,
    rx: 21,
    transform: "translate(367 116)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X",
    transform: "translate(608 34)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Drafting_of_the_white_paper_and_the_vision_for_the_the_next_few_years._Assembling_the_core_team_followed_by_the_partners_and_advisors._Creation_of_a_roadmap_for_the_first_9_months_and_a_business_model_for_the_next_two_years.",
    "data-name": "Drafting of the white paper and the vision for the the next few years. Assembling the core team followed by the partners and advisors. Creation of a roadmap for the first 9 months and a business model for the next two years.",
    transform: "translate(28 26)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35.974,
    y: 18
  }, "Drafting of the white paper and the vision for the"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.374,
    y: 38
  }, "the next few years. Assembling the core team followed by "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.374,
    y: 58
  }, "the partners and advisors. Creation of a roadmap for the "), /*#__PURE__*/React.createElement("tspan", {
    x: 30.926,
    y: 78
  }, "first 9 months and a business model for the next two "), /*#__PURE__*/React.createElement("tspan", {
    x: 259.9,
    y: 98
  }, "years.")))), /*#__PURE__*/React.createElement("g", {
    id: "Q-2",
    "data-name": "Q",
    transform: "translate(0 -423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-2",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q2",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q2"))), /*#__PURE__*/React.createElement("g", {
    id: "Q-3",
    "data-name": "Q",
    transform: "translate(-388 -88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6965",
    "data-name": "Group 6965",
    transform: "translate(499.738 2451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6985",
    "data-name": "Group 6985",
    transform: "translate(813 954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-4",
    "data-name": "Rectangle 1416",
    transform: "translate(431.262 532)",
    fill: "#ecdaf9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 289,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B\\xCATA_TEST",
    "data-name": "B\\xCATA TEST",
    transform: "translate(485.567 574)",
    fill: "#de8579",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BETA TEST")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6973",
    "data-name": "Group 6973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-3",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q3",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6974",
    "data-name": "Group 6974",
    transform: "translate(308 597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-4",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q4",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q4"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6979",
    "data-name": "Group 6979",
    transform: "translate(43 988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-5",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q1-2",
    "data-name": "Q1",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q1"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6987",
    "data-name": "Group 6987",
    transform: "translate(-104 1166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-6",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Q2-2",
    "data-name": "Q2",
    transform: "translate(1311.008 3024)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6988",
    "data-name": "Group 6988",
    transform: "translate(233 1486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1257-7",
    "data-name": "Ellipse 1257",
    transform: "translate(1270 2997)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "To_be_continued_",
    "data-name": "To be continued\\u2026",
    transform: "translate(1322.028 3025)",
    fill: "#a079b9",
    fontSize: 36,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "To be continued\u2026")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6981",
    "data-name": "Group 6981",
    transform: "translate(53 -933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__4_",
    transform: "translate(627.302 3237.018) rotate(9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13347",
    "data-name": "Path 13347",
    d: "M189.674,182.7l7.171,7.17,3.476-3.476a1.228,1.228,0,0,1,2.034.48l6.953,20.859a1.228,1.228,0,0,1-1.554,1.554L186.9,202.338a1.228,1.228,0,0,1-.48-2.034l3.476-3.476-7.17-7.171a1.229,1.229,0,0,1,0-1.738l5.214-5.214a1.228,1.228,0,0,1,1.734,0Z",
    transform: "translate(-182.362 -182.344)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "IT_CHOICE",
    "data-name": "IT CHOICE",
    transform: "translate(763 2437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_2",
    transform: "translate(-258.262 -362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-5",
    "data-name": "Rectangle 1416",
    transform: "translate(431.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 289,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "IT_CHOICES",
    "data-name": "IT CHOICES",
    transform: "translate(475.367 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IT CHOICES"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_2_INFOS"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -516, -391)",
    filter: "url(#Rectangle_1594)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-12",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 159,
    rx: 21,
    transform: "translate(516 391)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-2",
    "data-name": "X",
    transform: "translate(608 34)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Exploring_and_selecting_the_best_stack_to_develop_our_core_software_the_avatars_and_illustrated_scenes_generator._Like_Bitmoji_the_software_will_have_to_allow_a_colimetric_and_textural_modification_of_graphic_elements_directly_through_the_code_in_real_t",
    "data-name": "Exploring and selecting the best stack to develop our core software, the avatars and illustrated scenes generator. Like Bitmoji, the software will have to allow a colimetric and textural modification of graphic elements directly through the code (in real t",
    transform: "translate(27 13)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.621,
    y: 18
  }, "Exploring and selecting the best stack to develop our "), /*#__PURE__*/React.createElement("tspan", {
    x: 40.916,
    y: 38
  }, "core software, the avatars and illustrated scenes "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.321,
    y: 58
  }, "generator. Like Bitmoji, the software will have to allow "), /*#__PURE__*/React.createElement("tspan", {
    x: 0.168,
    y: 78
  }, "a colimetric and textural modification of graphic elements "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.374,
    y: 98
  }, "directly through the code (in real time), and the export "), /*#__PURE__*/React.createElement("tspan", {
    x: 163.263,
    y: 118
  }, "of the final file in *.svg.")))), /*#__PURE__*/React.createElement("g", {
    id: "DATA_build",
    "data-name": "DATA build",
    transform: "translate(423 2565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_4",
    transform: "translate(-269.262 -357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-6",
    "data-name": "Rectangle 1416",
    transform: "translate(431.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 325,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DATABASE_BUILD",
    "data-name": "DATABASE BUILD",
    transform: "translate(456.567 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DATABASE BUILD"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_4_INFOS"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -176, -519)",
    filter: "url(#Rectangle_1594-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-13",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 159,
    rx: 21,
    transform: "translate(176 519)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-3",
    "data-name": "X",
    transform: "translate(608 34)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Whether_it_is_to_store_the_code_the_APIs_or_users_data_the_database_will_have_to_be_fully_secured_and_capable_to_support_a_very_large_number_of_events_per_second_image_customization_requires_many_interactions_and_API_calls._We_will_build_technology-agn",
    "data-name": "Whether it is to store the code, the APIs or users data, the database will have to be fully secured and capable to support a very large number of events per second ; image customization requires many interactions and API calls. We will build technology-agn",
    transform: "translate(17 7)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.479,
    y: 18
  }, "Whether it is to store the code, the APIs or users data, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0.326,
    y: 38
  }, "the database will have to be fully secured and capable to "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.426,
    y: 58
  }, "support a very large number of events per second ; image "), /*#__PURE__*/React.createElement("tspan", {
    x: 10.316,
    y: 78
  }, "customization requires many interactions and API calls. "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.216,
    y: 98
  }, "We will build technology-agnostic and relevant use-cases "), /*#__PURE__*/React.createElement("tspan", {
    x: 25.668,
    y: 118
  }, "for centralized blockchain and smart contracts to be "), /*#__PURE__*/React.createElement("tspan", {
    x: 224.2,
    y: 138
  }, "future-proof.")))), /*#__PURE__*/React.createElement("g", {
    id: "ART",
    transform: "translate(1118 2498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_3",
    transform: "translate(-618.262 -470)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6967",
    "data-name": "Group 6967",
    transform: "translate(355 136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-7",
    "data-name": "Rectangle 1416",
    transform: "translate(431.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 289,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ART_GABARITS",
    "data-name": "ART GABARITS",
    transform: "translate(454.967 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ART GABARITS")))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_3_INFOS",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -871, -482)",
    filter: "url(#Rectangle_1594-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-14",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 189,
    rx: 21,
    transform: "translate(871 452)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-4",
    "data-name": "X",
    transform: "translate(608 -1)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "We_will_entirely_redesign_the_base_assets_and_templates_from_the_existing_BDouin_StoryMaker_apps_into_a_new_graphic_and_vectorial_format_for_the_new_software._We_will_rebuild_the_clothing_as_a_separate_module_to_allow_a_greater_range_of_character_customiza",
    "data-name": "We will entirely redesign the base assets and templates from the existing BDouin StoryMaker apps into a new graphic and vectorial format for the new software. We will rebuild the clothing as a separate module to allow a greater range of character customiza",
    transform: "translate(27 -18)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.421,
    y: 18
  }, "We will entirely redesign the base assets and templates "), /*#__PURE__*/React.createElement("tspan", {
    x: 30.821,
    y: 38
  }, "from the existing BDouin StoryMaker apps into a new "), /*#__PURE__*/React.createElement("tspan", {
    x: 35.868,
    y: 58
  }, "graphic and vectorial format for the new software."), /*#__PURE__*/React.createElement("tspan", {
    x: 25.774,
    y: 78
  }, "We will rebuild the clothing as a separate module to "), /*#__PURE__*/React.createElement("tspan", {
    x: 40.916,
    y: 98
  }, "allow a greater range of character customization. "), /*#__PURE__*/React.createElement("tspan", {
    x: 25.616,
    y: 118
  }, "Finally, the characters\u2019 structure will be reworked, "), /*#__PURE__*/React.createElement("tspan", {
    x: 30.663,
    y: 138
  }, "implementing wire-frame skeletons to enable greater "), /*#__PURE__*/React.createElement("tspan", {
    x: 61.316,
    y: 158
  }, "flexibility and animated scenes in the future.")))), /*#__PURE__*/React.createElement("g", {
    id: "MP1",
    transform: "translate(570 2831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_5",
    transform: "translate(-317.262 -387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-8",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MVP1",
    transform: "translate(599.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MVP1"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_5_INFOS",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -323, -761)",
    filter: "url(#Rectangle_1594-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-15",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 135,
    rx: 21,
    transform: "translate(323 785)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-5",
    "data-name": "X",
    transform: "translate(608 60)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "First_internal_alpha_release_of_the_software_allowing_the_Studio_BDouin_to_test_and_create_the_first_scenes.",
    "data-name": "First internal alpha release of the software allowing the Studio BDouin to test and create the first scenes.",
    transform: "translate(28 63)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.568,
    y: 18
  }, "First internal alpha release of the software allowing"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.674,
    y: 38
  }, "the Studio BDouin to test and create the first scenes.")))), /*#__PURE__*/React.createElement("g", {
    id: "beta_test",
    "data-name": "beta test",
    transform: "translate(498.738 2531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-9",
    "data-name": "Rectangle 1416",
    transform: "translate(431.262 532)",
    fill: "#ecd9f9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 289,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "B\\xCATA_TEST-2",
    "data-name": "B\\xCATA TEST",
    transform: "translate(485.567 574)",
    fill: "#a079b9",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BETA TEST"))), /*#__PURE__*/React.createElement("g", {
    id: "MVP_2",
    "data-name": "MVP 2",
    transform: "translate(557 3098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_7",
    transform: "translate(-319.262 -406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-10",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MVP2",
    transform: "translate(599.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MVP2"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_7_INFOS",
    transform: "translate(0 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -310, -1002)",
    filter: "url(#Rectangle_1594-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-16",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 134,
    rx: 21,
    transform: "translate(310 1027)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-6",
    "data-name": "X",
    transform: "translate(608 54)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "New_features_and_functionalities_release_first_closed-beta_invitation_to_select_Professional_Creators_for_the_creation_of_customized_scenery_BDouin_studio_will_continue_to_produce_additional_templates_to_enrich_the_generator_s_database._",
    "data-name": "New features and functionalities release, first closed-beta invitation to select Professional Creators for the creation of customized scenery BDouin studio will continue to produce additional templates to enrich the generator\\u2019s database. ",
    transform: "translate(28 35)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81.61,
    y: 18
  }, "New features and functionalities release,"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.763,
    y: 38
  }, "first closed-beta invitation to select Professional "), /*#__PURE__*/React.createElement("tspan", {
    x: 51.116,
    y: 58
  }, "Creators for the creation of customized scenery"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.916,
    y: 78
  }, "BDouin studio will continue to produce additional "), /*#__PURE__*/React.createElement("tspan", {
    x: 61.263,
    y: 98
  }, "templates to enrich the generator\u2019s database.")))), /*#__PURE__*/React.createElement("g", {
    id: "ART_SCHOOL",
    "data-name": "ART SCHOOL",
    transform: "translate(267 3211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_8",
    transform: "translate(-374.262 -399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-11",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 255,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ART_SCHOOL-2",
    "data-name": "ART SCHOOL",
    transform: "translate(582.367 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ART SCHOOL"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_8_INFOS",
    transform: "translate(0 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -20, -1131)",
    filter: "url(#Rectangle_1594-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-17",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 125,
    rx: 21,
    transform: "translate(20 1165)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-7",
    "data-name": "X",
    transform: "translate(608 65)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Partnerships_with_art_schools_to_form_users-creators_batches._Grant_program_launch_to_stimulate_the_platform_adoption.",
    "data-name": "Partnerships with art schools to form users-creators batches. Grant program launch to stimulate the platform adoption.",
    transform: "translate(28 51)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 142.758,
    y: 18
  }, "Partnerships with art schools"), /*#__PURE__*/React.createElement("tspan", {
    x: 132.558,
    y: 38
  }, "to form users-creators batches."), /*#__PURE__*/React.createElement("tspan", {
    x: 56.216,
    y: 58
  }, "Grant program launch to stimulate the platform"), /*#__PURE__*/React.createElement("tspan", {
    x: 244.6,
    y: 78
  }, "adoption.")))), /*#__PURE__*/React.createElement("g", {
    id: "NFT_MARKET_whitebook",
    "data-name": "NFT MARKET whitebook",
    transform: "translate(1156 3064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_6",
    transform: "translate(-235.262 -374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6969-2",
    "data-name": "Group 6969",
    transform: "translate(68.37 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-12",
    "data-name": "Rectangle 1416",
    transform: "translate(142.892 532)",
    fill: "#de8579",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 682,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "NFT_MARKET-whitebook",
    "data-name": "NFT MARKET-whitebook",
    transform: "translate(174.997 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Whitepaper v0.2-NFT Marketplace")))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_6_INFOS",
    transform: "translate(0 37.315)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -909, -1055.31)",
    filter: "url(#infos_rect)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "infos_rect-3",
    "data-name": "infos_rect",
    width: 637,
    height: 122,
    rx: 21,
    transform: "translate(909 1055)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-8",
    "data-name": "X",
    transform: "translate(608 33.685)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Addition_of_the_chapter_on_the_NFT_Marketplace_refined_vision_and_update_of_the_overall_whitepaper.",
    "data-name": "Addition of the chapter on the NFT Marketplace, refined vision and update of the overall whitepaper.",
    transform: "translate(28 33.685)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.521,
    y: 18
  }, "Addition of the chapter on the NFT Marketplace, refined "), /*#__PURE__*/React.createElement("tspan", {
    x: 66.416,
    y: 38
  }, "vision and update of the overall whitepaper.")))), /*#__PURE__*/React.createElement("g", {
    id: "ECONOMY",
    transform: "translate(1038 3243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_9",
    transform: "translate(-420.262 -376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-13",
    "data-name": "Rectangle 1416",
    transform: "translate(483.262 532)",
    fill: "#de8579",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 508,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "ECONOMY_MODEL",
    "data-name": "ECONOMY MODEL",
    transform: "translate(507.767 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Econ Model & Tokenomics"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_9_INFOS",
    transform: "translate(0 -17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -791, -1180)",
    filter: "url(#info_eco)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "info_eco-2",
    "data-name": "info_eco",
    width: 637,
    height: 165,
    rx: 21,
    transform: "translate(791 1174)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-9",
    "data-name": "X",
    transform: "translate(608 24)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Definition_and_economic_modelling_of_the_image_bank_BDouin_NFT_Marketplace._First_iteration_of_the_income_distribution_scheme_between_the_3_different_NFT_Maker_Participants:_studio_BDouin_pro._creators_and_users-creators._Study_of_the_monetization_of_ser",
    "data-name": "Definition and economic modelling of the image bank, BDouin NFT Marketplace. First iteration of the income distribution scheme between the 3 different NFT Maker Participants: studio BDouin, pro. creators and users-creators. Study of the monetization of ser",
    transform: "translate(22 4)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.768,
    y: 18
  }, "Definition and economic modelling of the image bank, "), /*#__PURE__*/React.createElement("tspan", {
    x: 20.568,
    y: 38
  }, "BDouin NFT Marketplace. First iteration of the income "), /*#__PURE__*/React.createElement("tspan", {
    x: 20.568,
    y: 58
  }, "distribution scheme between the 3 different NFT Maker "), /*#__PURE__*/React.createElement("tspan", {
    x: 20.516,
    y: 78
  }, "Participants: studio BDouin, pro. creators and users-"), /*#__PURE__*/React.createElement("tspan", {
    x: 0.274,
    y: 98
  }, "creators. Study of the monetization of services for B2B & "), /*#__PURE__*/React.createElement("tspan", {
    x: 96.858,
    y: 118
  }, "B2B2C (schools, institutions, brands\u2026)"), /*#__PURE__*/React.createElement("tspan", {
    x: 86.71,
    y: 138
  }, "Exploration of suitable tokenomics model ")))), /*#__PURE__*/React.createElement("g", {
    id: "MVP_1",
    "data-name": "MVP 1",
    transform: "translate(1221 3400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_10",
    transform: "translate(-319.262 -411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-14",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#de8579",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MVP1-2",
    "data-name": "MVP1",
    transform: "translate(599.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MVP1"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_10_INFOS",
    transform: "translate(0 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -974, -1304)",
    filter: "url(#Rectangle_1594-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-18",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 109,
    rx: 21,
    transform: "translate(974 1354)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-10",
    "data-name": "X",
    transform: "translate(608 80)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "First_bank_gallery_storing_and_displaying_the_images_generated_by_user_tests.",
    "data-name": "First bank/gallery storing and displaying the images generated by user tests.",
    transform: "translate(28 76)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 25.616,
    y: 18
  }, "First bank/gallery storing and displaying the images "), /*#__PURE__*/React.createElement("tspan", {
    x: 168.258,
    y: 38
  }, "generated by user tests.")))), /*#__PURE__*/React.createElement("g", {
    id: "MVP3",
    transform: "translate(726 3405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_11",
    transform: "translate(-319.262 -416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-15",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#a079b9",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MVP3-2",
    "data-name": "MVP3",
    transform: "translate(599.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MVP3"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_11_INFOS",
    transform: "translate(0 -95.387)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -479, -1263.61)",
    filter: "url(#Rectangle_1594-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-19",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 131,
    rx: 21,
    transform: "translate(479 1337)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-11",
    "data-name": "X",
    transform: "translate(607 104.387)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "More_features_are_released_the_main_one_allowing_the_participation_of_users-creators._New_modules_and_additional_assets_and_templates_continue_to_be_produced_by_studio_BDouin_and_customizations_are_provided_by_the_Pro.creators.",
    "data-name": "More features are released, the main one allowing the participation of users-creators. New modules and additional assets and templates continue to be produced by studio BDouin and customizations are provided by the Pro.creators.",
    transform: "translate(26 86.387)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.621,
    y: 18
  }, "More features are released, the main one allowing the "), /*#__PURE__*/React.createElement("tspan", {
    x: 127.405,
    y: 38
  }, "participation of users-creators."), /*#__PURE__*/React.createElement("tspan", {
    x: 5.268,
    y: 58
  }, "New modules and additional assets and templates continue "), /*#__PURE__*/React.createElement("tspan", {
    x: 15.521,
    y: 78
  }, "to be produced by studio BDouin and customizations are "), /*#__PURE__*/React.createElement("tspan", {
    x: 142.758,
    y: 98
  }, "provided by the Pro.creators.")))), /*#__PURE__*/React.createElement("g", {
    id: "V1_0",
    "data-name": "V1 0",
    transform: "translate(385 3515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_12",
    transform: "translate(-319.262 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-16",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#7d47a0",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "V1.0",
    transform: "translate(597.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V1.0"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_12_INFOS",
    transform: "translate(0 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -138, -1435)",
    filter: "url(#Rectangle_1594-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-20",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 148,
    rx: 21,
    transform: "translate(138 1446)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-12",
    "data-name": "X",
    transform: "translate(608 41)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "BDouin_NFT_Maker_Mobile_apps_release:_the_3_profiles_-_Studio_BDouin_pro._creators_and_users-creators_-_can_now_unleash_their_creativity_24_7_collaboratively_and_at_the_tips_of_their_fingers._At_this_stage_the_scenes_are_only_viewable_by_the_users_gene",
    "data-name": "BDouin NFT Maker Mobile apps release: the 3 profiles - Studio BDouin, pro. creators, and users-creators - can now unleash their creativity 24/7, collaboratively and at the tips of their fingers. At this stage, the scenes are only viewable by the users gene",
    transform: "translate(23 31)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.674,
    y: 18
  }, "BDouin NFT Maker Mobile apps release: the 3 profiles - "), /*#__PURE__*/React.createElement("tspan", {
    x: 35.816,
    y: 38
  }, "Studio BDouin, pro. creators, and users-creators -"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.416,
    y: 58
  }, "can now unleash their creativity 24/7, collaboratively "), /*#__PURE__*/React.createElement("tspan", {
    x: 30.926,
    y: 78
  }, "and at the tips of their fingers. At this stage, the "), /*#__PURE__*/React.createElement("tspan", {
    x: 15.521,
    y: 98
  }, "scenes are only viewable by the users generating them.")))), /*#__PURE__*/React.createElement("g", {
    id: "V1_1",
    "data-name": "V1 1",
    transform: "translate(256 3888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_13",
    transform: "translate(-319.262 -418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-17",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#7d47a0",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "V1.1",
    transform: "translate(597.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V1.1"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_13_INFOS",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -1787)",
    filter: "url(#Rectangle_1594-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-21",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 104,
    rx: 21,
    transform: "translate(9 1842)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-13",
    "data-name": "X",
    transform: "translate(608 86)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Major_release:_Dashboards_are_live_allowing_to_track_the_number_of_downloads_for_each_generated_image_among_other_data.",
    "data-name": "Major release: Dashboards are live, allowing to track the number of downloads for each generated image among other data.",
    transform: "translate(17 74)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20.568,
    y: 18
  }, "Major release: Dashboards are live, allowing to track"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.521,
    y: 38
  }, "the number of downloads for each generated image among "), /*#__PURE__*/React.createElement("tspan", {
    x: 234.453,
    y: 58
  }, "other data.")))), /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(860 3929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_14",
    transform: "translate(-368.262 -400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-18",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#de8579",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 255,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "MARKETING-2",
    "data-name": "MARKETING",
    transform: "translate(592.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MARKETING"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_14_INFOS",
    transform: "translate(0 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -613, -1849)",
    filter: "url(#infos_rect-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "infos_rect-4",
    "data-name": "infos_rect",
    width: 637,
    height: 125,
    rx: 21,
    transform: "translate(613 1883)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-14",
    "data-name": "X",
    transform: "translate(608 65)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Marketing_campaign_launch_targeting_the_primary_countries_-_Indonesia_Pakistan_Bangladesh_GCC_Egypt_Turkey_and_the_wide_Muslim_Show_fanbase_over_2_million_followers_combined_on_social_networks_",
    "data-name": "Marketing campaign launch, targeting the primary countries - Indonesia, Pakistan, Bangladesh, GCC, Egypt, Turkey) and the wide Muslim Show fanbase (over 2 million followers combined on social networks)",
    transform: "translate(28 51)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.963,
    y: 18
  }, "Marketing campaign launch, targeting the primary "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.216,
    y: 38
  }, "countries - Indonesia, Pakistan, Bangladesh, GCC, Egypt, "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.374,
    y: 58
  }, "Turkey) and the wide Muslim Show fanbase (over 2 million "), /*#__PURE__*/React.createElement("tspan", {
    x: 96.91,
    y: 78
  }, "followers combined on social networks)")))), /*#__PURE__*/React.createElement("g", {
    id: "V1_bank",
    "data-name": "V1 bank",
    transform: "translate(1085 4042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FRAME_15",
    transform: "translate(-319.262 -413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1416-19",
    "data-name": "Rectangle 1416",
    transform: "translate(553.262 532)",
    fill: "#d57468",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 59,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 167,
    height: 57,
    rx: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "V1.0-2",
    "data-name": "V1.0",
    transform: "translate(597.462 574)",
    fill: "#fff",
    fontSize: 34,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V1.0"))), /*#__PURE__*/React.createElement("g", {
    id: "FRAME_15_INFOS",
    transform: "translate(0 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -838, -1946)",
    filter: "url(#Rectangle_1594-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1594-22",
    "data-name": "Rectangle 1594",
    width: 637,
    height: 109,
    rx: 21,
    transform: "translate(838 1996)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "X-15",
    "data-name": "X",
    transform: "translate(608 84)",
    fill: "#fff",
    fontSize: 27,
    fontFamily: "FredokaOne-Regular, Fredoka One"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "X")), /*#__PURE__*/React.createElement("text", {
    id: "Opening_the_bridge_between_both_apps_providing_access_to_images_generated_through_NFT_Maker._Initially_monetization_will_be_only_available_for_B2C_before_extension_to_P2P.",
    "data-name": "Opening the bridge between both apps, providing access to images generated through NFT Maker. Initially, monetization will be only available for B2C before extension to P2P.",
    transform: "translate(28 62)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Ayuthaya"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.468,
    y: 18
  }, "Opening the bridge between both apps, providing access"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.916,
    y: 38
  }, "to images generated through NFT Maker. Initially, "), /*#__PURE__*/React.createElement("tspan", {
    x: 35.868,
    y: 58
  }, "monetization will be only available for B2C before "), /*#__PURE__*/React.createElement("tspan", {
    x: 203.905,
    y: 78
  }, "extension to P2P.")))), /*#__PURE__*/React.createElement("text", {
    id: "Click_on_the_labels_for_more_information",
    "data-name": "Click on the labels for more information",
    transform: "translate(681 2278)",
    fontSize: 14,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -60.158,
    y: 0
  }, "Click on the labels"), /*#__PURE__*/React.createElement("tspan", {
    x: -69.433,
    y: 15
  }, "for more information")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap2);
export default __webpack_public_path__ + "static/media/roadmap-2.57e4d79b9e4a890f36a51cfdb9c646a1.svg";
export { ForwardRef as ReactComponent };